export default __webpack_public_path__ + "static/media/background_order.53a71346.svg";